(function () {
  function parseTarget(value) {
    if (!value) return null;
    var date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function updateCountdown(el) {
    var target = parseTarget(el.getAttribute('data-target'));
    if (!target) return;
    var diff = Math.max(0, target.getTime() - Date.now());
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);
    el.textContent = days > 0 ? days + 'j ' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds) : pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  function initLive() {
    document.querySelectorAll('[data-duckrace-live-countdown]').forEach(function (el) {
      updateCountdown(el);
      setInterval(function () { updateCountdown(el); }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLive);
  } else {
    initLive();
  }
})();
